import { createContext, useContext } from 'react';
import type { Experience } from '../../experience.js';

/** What a page may ask of the shell around it. */
export interface ShellApi {
  experience: Experience;
  openDrawer: () => void;
  /** a page with a panel on the right (sources, the environment) asks for the narrow menu */
  setPanel: (open: boolean) => void;
}

export const ShellContext = createContext<ShellApi>({ experience: 'chat', openDrawer: () => undefined, setPanel: () => undefined });

export const useShell = () => useContext(ShellContext);
